import { render } from "./UserActivityMain.vue?vue&type=template&id=38ff7f00&scoped=true"
import script from "./UserActivityMain.vue?vue&type=script&lang=js"
export * from "./UserActivityMain.vue?vue&type=script&lang=js"

import "./UserActivityMain.vue?vue&type=style&index=0&id=38ff7f00&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ff7f00"]])

export default __exports__